import { render, staticRenderFns } from "./MonsterItemInformation.vue?vue&type=template&id=6a9777c4&"
import script from "./MonsterItemInformation.vue?vue&type=script&lang=js&"
export * from "./MonsterItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports